import { Component, Output, EventEmitter, OnInit, Input } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { UserPass } from "../../model/user-pass";
import { ActionButtonSubmit } from "../../model/action-button-submit";
import { AuthService } from "../../auth.service";
import { UsersService } from "../../services/users.service";
import { Messages } from "../../model/messages";
import { BehaviorSubject } from "rxjs";
import { LoggedIn } from "../../model/loggedIn";
import { User } from "../../model/users";
@Component({
  selector: "user-pass",
  templateUrl: "./user-pass.component.html",
  styleUrls: ["./user-pass.component.css"],
})
export class UserPassComponent implements OnInit {
  @Output() cancel = new EventEmitter<void>();

  userForm: FormGroup;
  user: UserPass;
  @Input() selectedUsername: string = "";
  showPassword = false;
  showConfirmation = false;
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);
  isLoading = false;
  constructor(
    private usersService: UsersService,
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    this.user = new UserPass(0, "", "", "");
  }

  ngOnInit(): void {
    const logged = this.authService.userdata;

    if (!logged.id || logged.id === 0) {
      this.usersService.users(this.authService.token).subscribe(() => {
        const user = this.usersService.getUserByUsername(logged.username);
        if (user) {
          const fixed = new LoggedIn(
            user.id!,
            user.name,
            user.displayname,
            user.email,
            user.supervisor === true,
            logged.lang
          );
          this.authService["_currentLoggedIn"].next(fixed);
        }
        this.initializeForm();
      });
    } else {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    const loggedIn = this.loggedInUser;

    const isDashboard = this.selectedUsername === loggedIn.username;

    if (isDashboard) {
      console.log("is dashboard ", isDashboard);
      this.userForm = this.fb.group({
        id: loggedIn.id,

        username: [loggedIn.username, Validators.required],
        password: "",
        confirmation: "",
      });
    } else {
      const selected = this.getSelectedUser();

      this.userForm = this.fb.group({
        id: selected?.id ?? 0,
        username: selected?.name ?? this.selectedUsername,
        password: "",
        confirmation: "",
      });
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmationVisibility() {
    this.showConfirmation = !this.showConfirmation;
  }

  savePass(action: ActionButtonSubmit): void {
    if (this.userForm.valid) {
      const loggedIn = this.loggedInUser;
      const isSupervisor = loggedIn?.supervisor;

      let id: number | null = null;
      const selected = this.getSelectedUser();

      if (this.selectedUsername === loggedIn.username) {
        id = loggedIn.id;
      } else if (isSupervisor && selected?.id) {
        id = selected.id;
      }

      if (!id) {
        this.messages.next(Messages.from({ user: ["user.id.invalid"] }));
        action.result(false);
        return;
      }

      if (!isSupervisor && id !== loggedIn.id) {
        this.messages.next(
          Messages.from({ user: ["user.password.change.not.allowed"] })
        );
        action.result(false);
        return;
      }

      if (id !== null && id !== 0) {
        this.userForm.patchValue({
          id: id,
          username: this.selectedUsername,
        });
      }

      this.user = this.userForm.value;

      const token = this.authService.token;
      this.isLoading = true;

      const user = new UserPass(
        id,
        this.user.username,
        this.user.password,
        this.user.confirmation
      );

      this.usersService.changePassword(token, user).subscribe(
        (messages) => {
          this.isLoading = false;
          this.messages.next(messages);
          if (messages.hasAnyMessages) {
            action.result(false);
          } else {
            action.result(true);
            this.cancelPasswordChange();
          }
        },
        (error) => {
          this.isLoading = false;
          this.messages.next(
            Messages.from({ user: ["user.changePassword.failed", error] })
          );
          action.result(false);
        }
      );
    } else {
      this.messages.next(Messages.from({ user: ["user.form.invalid"] }));
      action.result(false);
    }
  }

  cancelPasswordChange() {
    this.cancel.emit();
  }
  get loggedInUser(): LoggedIn {
    const user = this.authService.userdata;

    if (!user.username || user.username.trim() === "") {
      const stored = localStorage.getItem("currentLoggedIn");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          return new LoggedIn(
            parsed.id ?? 0,
            parsed.username ?? "",
            parsed.label ?? "",
            parsed.email ?? "",
            parsed.supervisor === true || parsed.supervisor === "true",
            parsed.lang ?? ""
          );
        } catch (e) {
          console.error("Erro ao parsear currentLoggedIn do localStorage:", e);
        }
      }
    }

    return user;
  }

  private getSelectedUser(): User | null {
    let selected = this.usersService.selected;
    if (!selected || selected.name !== this.selectedUsername) {
      selected = this.usersService.getUserByUsername(this.selectedUsername);
    }
    return selected;
  }
}
